module.exports = __webpack_public_path__ + "img/ET.cb97a7c9.svg";